export const GA_CHANGE_PAGE_ACTION = 'ChangePage';

/****************************** STATSIG CONSTANTS ********************************/
export const STATSIG_EXPERIENCE_FILTER_ClICK =
    'Search - Filters - Click - Experience';
